
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.07 5.31997C16.26 5.99997 18 7.73997 18.68 9.92997C18.87 10.56 19.44 11 20.09 11H20.13C21.13 11 21.85 10.04 21.56 9.08997C20.59 5.90997 18.08 3.39997 14.9 2.42997C13.96 2.13997 13 2.85997 13 3.85997V3.89997C13 4.55997 13.44 5.12997 14.07 5.31997ZM18.68 14.07C18 16.27 16.26 18 14.07 18.68C13.44 18.87 13 19.44 13 20.09V20.13C13 21.13 13.96 21.85 14.91 21.56C18.09 20.59 20.6 18.08 21.57 14.9C21.86 13.95 21.14 12.99 20.15 12.99H20.1C19.44 13 18.87 13.44 18.68 14.07ZM11 20.11C11 19.44 10.55 18.87 9.91 18.67C7.07 17.78 5 15.13 5 12C5 8.86997 7.07 6.21997 9.91 5.32997C10.55 5.12997 11 4.55997 11 3.88997V3.87997C11 2.87997 10.03 2.13997 9.07 2.43997C4.98 3.68997 2 7.49997 2 12C2 16.5 4.98 20.31 9.07 21.56C10.03 21.86 11 21.12 11 20.11Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-donut-large`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDonutLarge

    ```js
    <b-new-b-icon-donut-large />
    ```
</docs>


